<div class="iot-platform-ui-dynamic-dropdown flex flex-row items-center">
  <mat-form-field class="block w-full" color="accent">
    <mat-label>{{ placeholder() | translate }}</mat-label>
    <input
      #searchInput
      matInput
      autocomplete="off"
      type="text"
      (keyup)="onSearchTermChange(searchInput.value.trim())"
      [disabled]="disabled()"
      [matAutocomplete]="auto"
    />
    @if (isLoading()) {
      <mat-progress-spinner matSuffix [diameter]="20" color="accent" mode="indeterminate" />
    }
    @if (hasClearButton()) {
      <button matSuffix mat-icon-button (click)="clearSearch(); searchInput.value = ''" [attr.aria-label]="'Clear'" class="!h-5 !w-5 !-translate-y-1 !p-0">
        <mat-icon class="!text-[20px] !leading-5">close</mat-icon>
      </button>
    }
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayFn()"
      autoActiveFirstOption
      panelClass="dynamic-dropdown-panel"
      (optionSelected)="onItemSelected($event.option.value)"
    >
      <!-- Items List -->
      @for (item of items(); track trackBy()(item)) {
        <mat-option [value]="item" class="!border-b !border-solid !border-[rgba(0,0,0,0.12)] !px-0 shadow-[0_2px_2px_rgba(0,0,0,0.04)]">
          @if (itemTemplate) {
            <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }" />
          } @else {
            <div class="py-1">
              <span class="block text-xs">{{ displayFn()(item) }}</span>
              @if (getItemDescription()) {
                <span class="block text-[10px] text-[#757575]">{{ getItemDescription()!(item) }}</span>
              }
            </div>
          }
        </mat-option>
      }

      <!-- Empty State -->
      @if (isEmpty()) {
        <mat-option class="!pointer-events-none !cursor-default">
          <span class="text-xs !text-[#394c5a]">{{ emptyMessage() | translate }}</span>
        </mat-option>
      }

      <!-- Load More Button -->
      @if (hasMore()) {
        <button
          (click)="onLoadMore()"
          [disabled]="isLoading()"
          mat-button
          class="!block !h-10 !min-h-0 !w-full !rounded-none !p-0 text-center !text-sm !leading-10 !text-[#394c5a]"
        >
          {{ loadMoreMessage() | translate }} ({{ 'IOT_DICTIONARY.TOTAL' | translate }}: {{ total() }})
        </button>
      }

      <!-- Error State -->
      @if (hasError()) {
        <mat-option class="!pointer-events-none !cursor-default">
          <div class="flex flex-row items-center">
            <span>{{ errorMessage() | translate }}</span>
            <button (click)="$event.stopPropagation(); retry()" mat-icon-button color="warn" class="!pointer-events-auto">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</div>
